export const FEATURE_COMMUNICATION = 'communication'
export const FEATURE_VIEW_REPORTS = 'report'
export const FEATURE_ENROLLMENT_PROGRAM = 'program'
export const FEATURE_ENROLLMENT_EVENT = 'event'
export const FEATURE_PROGRAM_BUILDER = 'program_builder'
